import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_ENDPOINTS } from '../constants/api.constants';
import { ApiResponse } from '../interfaces/api-response.model';
import {
  BusinessCheckupSettingsRequest,
  BusinessCheckupSettingsResponse,
  CheckupSettingsRequest,
  CheckupSettingsResponse,
} from '../interfaces/appointment-info.model';

/**
 * 檢查相關資料服務
 */
@Injectable({
  providedIn: 'root',
})
export class AppointmentInfoService {
  // axiosHttpService: AxiosHttpService = inject(AxiosHttpService);
  http: HttpClient = inject(HttpClient);

  /**
   * 查詢檢查相關資料欄位
   * @param request 查詢檢查相關資料請求
   */
  checkupSettings(
    request: CheckupSettingsRequest
  ): Observable<ApiResponse<CheckupSettingsResponse>> {
    return this.http.post<ApiResponse<CheckupSettingsResponse>>(
      API_ENDPOINTS.CHECKUP_SETTINGS,
      request
    );
  }

  /**
   * 查詢企業檢查相關資料欄位
   *
   * 根據功能查詢所需資料，資料寄送方式、報告語言、衣服尺寸、餐食選項。當查詢 dataType=2、3 時，僅需要帶[orgNo][gender]
   * @param request 企業檢查相關資料請求
   */
  businessCheckupSettings(
    request: BusinessCheckupSettingsRequest
  ): Observable<ApiResponse<BusinessCheckupSettingsResponse>> {
    
    return this.http.post<ApiResponse<BusinessCheckupSettingsResponse>>(
      API_ENDPOINTS.BUSINESS_CHECKUP_SETTINGS,
      request
    );
  }
}
